import { Typography } from '@mui/material';
import React from 'react';
import useData from '../../Hooks/useData';
import './Footer.css'

const Footer = () => {
    const {name} = useData() 
    return (
        <div className="footer text-white d-flex justify-content-between align-items-center">
            <div className="footer-left">
            <Typography className="footer-name">{name}</Typography>
            </div>
            <div className="footer-right">
                <Typography className="footer-copyright">
                    Designed and developed by <a href="/" target="_blank" rel="noopener noreferrer">iazadur</a>
                </Typography>
            </div>
        </div>
    );
};

export default Footer;